import { map } from 'rxjs/operators';
import { UserService } from '../services/user.service';
import { McmdRole, SignOnPolicy, User } from '../models/user.model';
import { shouldHidePolicy } from '../constants/policy-filter.constants';
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  OnChanges,
  SimpleChanges,
  Renderer2,
  ElementRef,
  ChangeDetectorRef
} from '@angular/core';
import {firstValueFrom, Subject} from 'rxjs';
import { Router } from '@angular/router';

import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
  ValidationErrors,
  FormGroup, FormArray, FormControl, AbstractControl
} from '@angular/forms';
import { Alert, AlertType } from '../../shared/alert.model';
import { MessageService } from '../../shared/message.service';
import { getAlertMessage } from '../../shared/api-loaders';
import { SecurityService } from '../../shared/security.service';
import { RoleDisciplineValidator } from '../validators/role-discipline-validator';
import { UserDetailService } from '../services/user-detail.service';
import { NgbAccordion, NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { getRoleFromName } from '../shared';
import {
  LpcRoles,
  PdOfficeData,
  Region,
  RolesDisciplines,
  UserDetailOptionsFacility
} from '../models/user-detail-options';
import { UserTypeNames } from '../models/user-type-names';
import { CustomValidators } from '../validators/optional-email-validator';
import { Select2Option } from '../../shared/select2-option';
import {
  DownlineTreeviewItem, TreeviewConfig, TreeviewItem, TreeviewComponent,
  TreeviewEventParser, OrderDownlineTreeviewEventParser
} from '@laijuthomas/ngx-treeview';
import { IUserRegion } from '../models/user-region.model';
import { TreeviewCustomConfig } from '../../treeview/treeview-custom-config';
import * as _ from 'lodash'
import { ProductNames } from '../models/ProductNames';
import { CreateUserMessageComponent } from '../user-create-message/user-create-message.component';
import { environment } from '../../../environments/environment';
import { AccessSectionValidator } from '../validators/access-section-validator';
import { ToggleService } from '../../shared/toggle/toggle.service';
import { arrayToObject, copyToClipboard } from '../../shared/app-util';
import { MessageType } from '../../shared/messageType';
import { getPrefixesOptions } from '../models/Prefixes';
import { UserCustomerService } from '../services/user-customer.service';
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';
import {getMultiSelectSettings, getMultiSelectTexts} from "../../shared/DropdownHelper";
import {IMultiSelectOption} from "ngx-bootstrap-multiselect";
import { CustomerConfigurationParameters } from '../../ect-feature/models/customerConfigurationParameters';
import { ConfigurationService } from '../../ect-feature/services/configuration.service';
import { Products } from '../../ect-feature/models/configuration-features';
import { PasswordValidationService } from '../../shared/services/password-validation.service';
import {CustomerService} from "../../ect-feature/services/customer.service";
import {FacilityRoleAssignments} from "../models/FacilityRoleAssignments.model";

@Component({
    selector: 're-user-create',
    templateUrl: './user-create.component.html',
    styleUrls: ['./user-create.component.scss'],
    providers: [
        { provide: TreeviewConfig, useClass: TreeviewCustomConfig },
        { provide: TreeviewEventParser, useClass: OrderDownlineTreeviewEventParser }
    ],
    standalone: false
})
export class UserCreateComponent implements OnInit, OnDestroy {

  @ViewChild(TreeviewComponent, { static: false }) treeviewComponent: TreeviewComponent;
  private _success = new Subject<string>();
  public accessDisabled = false;
  successAlert: Alert;
  alert: Alert;
  waiting: boolean;
  sameAsUsername = true;
  createUserForm: UntypedFormGroup;
  user: User = new User();
  sendActivationEmail: boolean;
  changePasswordFirstLogin: boolean;
  passwordSetBy: string;
  selectedFederatedLoginIdDomain: string;
  roles: any[];
  disciplines: any[];
  userTypeData: any[];
  lpcRoleOptions: IMultiSelectOption[] = [];
  multiSelectSettings = getMultiSelectSettings();
  multiSelectSettingsTexts = getMultiSelectTexts();
  isCustomRole = false;
  corporations: any[];
  environments: Select2Option[];
  domainOptions: Select2Option[]
  careSettings: any[];
  userDetailOptions: RolesDisciplines[];
  config = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasFilter: true
  });
  selectedFacilities: any[] = [];
  showPassword: boolean = true;
  isLocationAdmin = false;
  isUserLocationLimitedAdmin = false;
  mcmdRoles: McmdRole[] = [];
  signOnPolicies: string[] = [];
  allPolicies: SignOnPolicy[] = [];
  minDate = new Date();
  showPhysicianNppaCheckbox: boolean = false;
  isPhysicianNppaUser: boolean = false;
  corporateStructureJson: string;
  corporateStructureObject: any;
  physicianNppaTemplates: any[];
  facilitiesForRoleAssignment: { name: string; id: number; }[];
  facilityRoles: string[] = ['','Cardiologist', 'Clinical Nurse Specialist', 'Dentist', 'Internist', 'NP/PA', 'Ophthalmologist', 'Optometrist', 'Physician', 'Podiatrist', 'Psychiatrist', 'Psychologist', 'Urologist'];
  facilityRoleAssignmentForm!: FormGroup;
  isFacilityRoleAssignmentFormLoaded: boolean = false;
  newFacilityRoleAssignments: FacilityRoleAssignments[] = [];
  searchControl: FormControl;
  selectAllChecked = false;
  facilityListScrolled = false;
  defaultRole = '';
  showSelectAll = false;

  adminToolRoleDataDictionary = new Set<string>();
  private _adminToolRoleData: Select2Option[];
    public get adminToolRoleData(): Select2Option[] {
        return this._adminToolRoleData;
    }
    public set adminToolRoleData(value: Select2Option[]) {
      this._adminToolRoleData = value;
      this.adminToolRoleDataDictionary = new Set();
      this.adminToolRoleDataDictionary.clear();
      value.forEach(x => {
        this.adminToolRoleDataDictionary.add(x.id);
      });
  }

  public mcmdRoleData: Select2Option[] = [];
  public eFormsRoleData: Select2Option[] = [];
  public ppRoleData: Select2Option[] = [];
  public rtoRoleData: Select2Option[] = [];

  adminToolRoleNonLmaData: Select2Option[];
  adminToolRoleDefaultData: Select2Option[];
  // RDL access
  regionsTree: Region[];
  selectedRegions: IUserRegion[];
  corporateLimited = false;
  pdOfficeData : Select2Option[];
  isDisciplineRequired = false;

  prefixData: Select2Option[] = getPrefixesOptions();
  _selectedDomain: string;
  get selectedDomain() {
    return this._selectedDomain;
  }
  set selectedDomain(value: string) {
    this._selectedDomain = value;
    if (this.createUserForm.get("sameAsUsername").value) {
      this.selectedFederatedLoginIdDomain = value;
    }
  }

  public passwordSetByOptions = [
    { value: 'User', display: 'User Activation Email' },
    { value: 'Admin', display: 'Admin' }
  ];

  private reLowerCase = /(?=.*[a-z])/;
  private reUpperCase = /(?=.*[A-Z])/;
  private reNumberCase = /(?=.*\d)/;
  private reSpecialCharacterCase = /(?=(?:.*?[!@#$%*()_+^&}{:;?.]){1})/;
  private reMinLengthCase = /(?=^.{9,}$)/;
  private reEmailCase = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
  isAccessCollapsed: boolean;
  isProfileDetailCollapsed: boolean;
  isCredentialsCollapsed: boolean;
  corporateData: RolesDisciplines;
  careSettingData: RolesDisciplines;
  snfProductName: string;
  slProductName: string;
  lpcProductName: string;
  ppProductName: string;
  pdProductName: string;
  trueSenseProductName: string;
  sigmaCareProductName: string;
  enableSLAutoProvisioning: boolean;
  showSnfAccess: boolean = true;
  showLpcAccess: boolean = true;
  showPPAccess = false;
  showRTOAccess = false;
  showTrueSenseAccess = false;
  showSigmaCareAccess = false;
  showPdOfficeData: boolean = false;
  showSolutionsForBusinessAccess: boolean = false;
  solutionsForBusinessModuleOptions: IMultiSelectOption[] = [];
  solutionsForBusinessProductName: string;
  adminAccess: string;
  multicareMobile: string;
  multicareMobileEnabled: boolean = false;
  multicareEformsEnabled: boolean = false;
  customerConfigurationParameters: CustomerConfigurationParameters;
  showMulticareSection: boolean = false;
  loading: boolean = false;
  signOnOptions: IMultiSelectOption[] = [];
  isCustomerAdmin = false;
  environmentLoading = false;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    public userService: UserService,
    private messageService: MessageService,
    private securityService: SecurityService,
    private modalService: NgbModal,
    private userDetailService: UserDetailService,
    private toggleService: ToggleService,
    private userCustomerService:UserCustomerService,
    private renderer: Renderer2,
    private element: ElementRef,
    private configurationService: ConfigurationService,
    private passowrdValidationSvc : PasswordValidationService,
    private customerService: CustomerService,
    private cdr: ChangeDetectorRef
  ) {
    this.passwordSetBy = this.passwordSetByOptions[ 1 ].value;
    this.snfProductName = ProductNames.SNF;
    this.slProductName = ProductNames.SL;
    this.lpcProductName = ProductNames.LPC;
    this.ppProductName = ProductNames.PP;
    this.pdProductName = ProductNames.PD;
    this.trueSenseProductName = ProductNames.TS;
    this.sigmaCareProductName = ProductNames.SIGMACARE;
    this.adminAccess = ProductNames.AA;
    this.multicareMobile = ProductNames.MCMD;
    this.solutionsForBusinessProductName = ProductNames.S4B;
    this.enableSLAutoProvisioning = environment.enableSLAutoProvisioning.toLowerCase() === "true";

    this.createUserForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      middleName: [''],
      userName: ['', [Validators.required, (control) => this.userNameFormat(control)]],
      email: ['', CustomValidators.optionalEmailValidator],
      password: '',
      passwordSetBy: this.passwordSetByOptions[1].value,
      changePasswordFirstLogin: true,
      sendActivationEmail: false,
      primaryPhone: ['', Validators.pattern(this.phoneNumPattern)],
      ext: ['', [Validators.pattern(/^\d+$/)]],
      mobilePhone: ['', Validators.pattern(this.phoneNumPattern)],
      userType: [''],
      corporationName: [''],
      careSettingName: [''],
      configId: ['', Validators.required],
      role: [''],
      primaryDiscipline: [''],
      adminToolRole: ['', Validators.required],
      federatedIdentity: [null, _ => this.federatedIdentityValidator(this.createUserForm)],
      federatedLoginID: ['', [Validators.maxLength(100), _ => this.validateFederatedLoginIdValidator(this.createUserForm), (control) => this.userNameFormat(control)]],
      slProvisioned: true,
      trueSenseProvisioned: false,
      sigmaCareProvisioned: false,
      lpcRoles: [],
      paymentPortalRole:[''],
      pdProvisioned: true,
      lpcProvisioned: true,
      ppProvisioned:true,
      officeId: '',
      sameAsUsername: false,
      title: [],
      prefix: [],
      customerEmployeeId: [''],
      usernameDomains: [],
      selectedFederatedLoginIdDomain:[],
      tokenManagement: false,
      scimMapping: false,
      mcmdRole: [''],
      eFormsRole: [''],
      rtoRole: [''],
      deactivationDate: [''],
      physicianNppaEnabled: false,
      usesMatrixcare: false,
      solutionsForBusinessModules: []
    });

    this.facilityRoleAssignmentForm = this.fb.group({
      checked: false,
      id: [''],
      name: [''],
      role:['']
    });
  }


  private userNameFormat(control: UntypedFormControl) {
    const value = control.value;
    if (!value)
      return null;

    if (value.indexOf('@') >= 0) {
      return { format: 'invalid' };
    }
    return null;
  }

  @ViewChild(NgbAccordion, { static: false })
  accordion: NgbAccordion;

  public careSettingName = UserTypeNames.CareSetting;

  public activeIds = [];

  public isExpanded(panelId: string) {
    let expanded = false;
    this.accordion.panels.forEach(x => {
      if (x.isOpen && x.id == panelId)
        expanded = true;
      return false;
    });

    return expanded;
  }

  public careSettingChanged(careSettingName: string) {
    if(this.treeviewComponent) { this.treeviewComponent.onFilterTextChange(''); }
    let currentCorporation = this.getCurrentCorporation();
    if (currentCorporation) {
      let currentFacility: UserDetailOptionsFacility | any = currentCorporation.facilities.firstOrDefault(x => x.name == this.user.careSettingName, {});
      let disciplines = currentFacility.disciplines || [];
      this.disciplines = disciplines.map(x => { return { text: x, id: x, data: x }; }).sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
      this.userDetailService.addDefaultOption(this.disciplines);
      this.userTypeChanged(false);
    }
  }
  public corporationChanged(corporationName: string) {
    if(this.treeviewComponent) { this.treeviewComponent.onFilterTextChange(''); }
    if (!this.user.corporationName || !this.user.corporationName.trim()) {
      this.roles = [];
      this.careSettings = [];
      this.disciplines = [];
      this.selectedRegions = [];
      this.user.role = "";
      this.user.careSettingName = "";
      this.user.primaryDiscipline = "";
      this.isDisciplineRequired = false;
      this.roleChanged(null);
      return;
    }

    this.loadCareSettings();
    this.careSettingChanged(null);
    if (this.createUserForm.get('corporationName').value) {
      this.createUserForm.get('corporationName').setErrors(null);
    }
  }


  private getCurrentCorporation() {
    let currentCorporation = this.userDetailOptions.firstOrDefault(x => x.configId == this.user.configId && x.name == this.user.corporationName);
    return currentCorporation;
  }

  private loadCareSettings() {
    let currentCorporation = this.getCurrentCorporation();
    if (currentCorporation) {
      this.regionsTree = currentCorporation.regions;
      this.userDetailService.sortRegionsTree(this.regionsTree);
      this.careSettings = currentCorporation.facilities.map(x => { return { text: x.name, id: x.name, data: x }; });
    }
  }

  public corporationSettings = {
    tags: false, placeholder: 'Not Selected', width: '100%',
    //  createTag: (params) => this.createRoleOption(params)
  };
  public careSettingSettings = {
    tags: false, placeholder: 'Not Selected', width: '100%',
    //  createTag: (params) => this.createRoleOption(params)
  };
  public environmentSettings = {
    tags: false, placeholder: 'Not Selected', width: '100%',
    //  createTag: (params) => this.createRoleOption(params)
  };

  public pdOfficeSettings = {
    tags: false, placeholder: 'Not Selected', width: '100%',
  };

  expandAll() {

    this.isAccessCollapsed = false;
    this.isCredentialsCollapsed = false;
    this.isProfileDetailCollapsed = false;
  }
  collapseAll() {
    this.isAccessCollapsed = true;
    this.isCredentialsCollapsed = true;
    this.isProfileDetailCollapsed = true;
  }
  private phoneNumPattern = /^[2-9][0-9]{9}$/;

  sameAsUsernameChanged(value: any) {
    let control = this.createUserForm.get("federatedLoginID");
    if (value) {
      control.disable();
      control.setValue(this.createUserForm.get("userName").value);
      this.selectedFederatedLoginIdDomain = this.selectedDomain;
    }
    else
      control.enable();
  }

  employeeIdEnabled = false;
  async ngOnInit() {

    this.userService.getMcmdRoles().subscribe((roles) => {
      this.mcmdRoleData = roles.map(x => { return { text: x.name, id: x.name, data: x }; });
      this.mcmdRoleData.splice(1, this.mcmdRoleData.length - 1);
      this.mcmdRoleData.unshift({ id: "Not Selected", text: "Not Selected", selected: true });
    });

    this.eFormsRoleData = [
      { id: "Not Selected", text: "Not Selected", selected: true },
      { id: "EFormsStaff", text: "eForms Staff" },
      { id: "EFormsAdmin", text: "eForms Admin" }
    ];

    const roles = this.userService.getPPRoleIdText();
    this.ppRoleData = roles.map(x => ({ text: x.text, id: x.id, data: x }));

    const rtoRoles = this.userService.getRTORoleIdText();
    this.rtoRoleData = rtoRoles.map(x => ({ text: x.text, id: x.id, data: x }));

    this.employeeIdEnabled = environment.employeeIdEnabled;
    this.isLocationAdmin = await this.securityService.isUserManagementLocalAdmin().toPromise();
    this.isCustomerAdmin = await this.securityService.isUserManagementCorporateAdmin().toPromise();
    this.securityService.isUserLocationLimitedAdmin().subscribe(x => this.isUserLocationLimitedAdmin = x);

    this.sameAsUsernameChanged(this.createUserForm.get("sameAsUsername").value); //manually run the change code

    this.createUserForm.get("federatedIdentity").valueChanges.subscribe(value => {
      if (!value) {
        this.createUserForm.get("federatedLoginID").setValue(null);
      }
      else {
        this.createUserForm.get("password").setValue(null);
      }
      this.createUserForm.get("sameAsUsername").setValue(false);
      this.valueChange();
    })


    this.createUserForm.get("sameAsUsername").valueChanges.subscribe(value => {
      this.sameAsUsernameChanged(value);
    })

    this.createUserForm.get("userName").valueChanges.subscribe(value => {
      if (this.createUserForm.get("sameAsUsername").value) {
        this.createUserForm.get("federatedLoginID").setValue(this.createUserForm.get("userName").value);
      }
    })

    this.user.adminToolRole = 'RU';
    this.user.slProvisioned = this.enableSLAutoProvisioning;
    this.user.pdProvisioned = this.showPdOfficeData;
    this.user.lpcProvisioned = this.showLpcAccess;
    this.user.ppProvisioned = this.showPPAccess;
    this.user.trueSenseProvisioned = this.showTrueSenseAccess;
    this.user.sigmaCareProvisioned = this.showSigmaCareAccess;

    this.createUserForm.get('passwordSetBy').valueChanges.subscribe(
      (passwordSetBy: string) => {
        this.passwordSetBy = passwordSetBy;
        if (passwordSetBy === 'User') {
          this.createUserForm.get('password').setValidators(null);
          this.createUserForm.get('password').updateValueAndValidity();
        }
      }
    );
    this.createUserForm.get('email').valueChanges.subscribe((value: string) => {
      this.isDummyEmail = this.userService.isDummyEmail(value);
      if (this.isDummyEmail) {
        this.passwordSetBy = 'Admin';
      }
      else {
        this.passwordSetBy = 'User';
      }

      this.createUserForm.get("passwordSetBy").setValue(this.passwordSetBy);

    }
    );

    this.createUserForm.get('federatedIdentity').valueChanges.subscribe((value: boolean) => {
      this.user.federatedIdentity = value;
    });

    let usernameDomains = await this.securityService.getAvailableDomains();
    this.domainOptions = usernameDomains.map(x => { return { text: "@"+x, id: x } });
    this.selectedDomain = usernameDomains[ 0 ];
    this.selectedFederatedLoginIdDomain = usernameDomains[ 0 ];


    await this.loadOptions();
    this.addCustomData(this.roles, this.user.role);
    this.addCustomData(this.disciplines, this.user.primaryDiscipline);
    this.createUserForm.controls['configId'].setErrors({ 'invalid': true });

    const configId = this.user.configId;
    if (configId && this.user.physicianNppaEnabled) {
      this.isPhysicianNppaUser = true;
      await this.fetchAndProcessCorporateStructure(configId);
      // Trigger change detection to update the view
      this.cdr.detectChanges();
      // Build a Set of facility IDs the current user can access (from referenceData, already LMA-filtered)
      const accessibleFacilityIds = new Set<number>();
      for (const option of this.userDetailOptions) {
        if (String(option.configId) === String(this.user.configId)) {
          option.facilities.forEach(f => accessibleFacilityIds.add(f.id));
          break;
        }
      }

      // Use the full facility list from corporateStructureObject (already fetched, not LMA-filtered)
      const allFacilities: { id: number; name: string }[] =
        (this.corporateStructureObject?.facilities || []).map((f: any) => ({ id: f.id, name: f.name }));

      this.facilitiesForRoleAssignment = allFacilities;

      this.facilityRoleAssignmentForm = this.fb.group({
        facilities: this.fb.array(allFacilities.map(facility =>
          this.fb.group({
            checked: false,
            id: [facility.id, Validators.required],
            name: [facility.name, Validators.required],
            role: [''], // Default to an empty if roles are undefined
            accessible: [!this.isLocationAdmin || accessibleFacilityIds.has(facility.id)]
          })
        ))
      });
      this.showSelectAll = this.isCustomerAdmin ||
        (this.isLocationAdmin && !this.isUserLocationLimitedAdmin && accessibleFacilityIds.size === allFacilities.length);
// Set the flag to true after the form is initialized
      this.isFacilityRoleAssignmentFormLoaded = true;
    }

// Initialize the `visible` property for each facility
    this.facilities.controls.forEach((control) => {
      if (!control.get('visible')) {
        (control as FormGroup).addControl('visible', new FormControl(true));
      }
    });
  }

  filterFacilities(searchTerm: string): void {
    const facilities = this.facilities.controls;
    facilities.forEach((control) => {
      const facilityName = control.get('name')?.value?.toLowerCase() || '';
      const matches = facilityName.includes(searchTerm.toLowerCase());
      control.get('visible')?.setValue(matches);
    });
  }

  get facilities(): FormArray {
    return this.facilityRoleAssignmentForm.get('facilities') as FormArray;
  }

  private async fetchAndProcessCorporateStructure(configId: string): Promise<void> {
    try {
      let corporateStructure = await this.customerService.getCorporateStructureByConfigId(configId).toPromise();

      // Convert to JSON string for debugging or inspection
      this.corporateStructureJson = JSON.stringify(corporateStructure);
      // Parse back to JSON object (if needed)
      this.corporateStructureObject = JSON.parse(this.corporateStructureJson);
      // Extract specific fields (e.g., roles)
      this.physicianNppaTemplates = this.corporateStructureObject?.roles || [];
      this.physicianNppaTemplates = this.physicianNppaTemplates
        .filter(role => role.specialUserTokenDesc?.toLowerCase() === "specialuser:physician".toLowerCase() ||
          role.specialUserTokenDesc?.toLowerCase() === "specialuser:nppa".toLowerCase());
    } catch (error) {
      console.error('Error fetching corporate structure:', error);
    }
  }

  validateFederatedLoginIdValidator(form: UntypedFormGroup): ValidationErrors | any {
    if (!this.customerFederationEnabled)
      return null;
    if (!this.federationLoginIdEnabled)
      return null;

    var federatedIdentity = form.controls[ "federatedIdentity" ].value;
    if (!federatedIdentity)
      return null;

    var federatedLoginID = form.controls[ "federatedLoginID" ].value;

    if (federatedLoginID)
      return null;

    return { required: true };
  }

  federatedIdentityValidator(form: UntypedFormGroup): ValidationErrors | any {
    if (!this.customerFederationEnabled)
      return null;

    var val = form.controls[ "federatedIdentity" ].value;
    if (val === true || val === false)
      return null;

    return { required: true };
  }


  addCustomData(options: any[], name: string): any {
    if (!options)
      return;

    if (!name || name.trim() == "")
      return;

    for (var i = 0; i < options.length; i++) {
      let option = options[ i ];
      if (option.text == name) {
        return;
      }
    }
    options.push({ text: name, id: name, data: { disciplineRequired: false, name: name } });
  }

  public checkProductAccess(key: string) {
    switch(key) {
      case Products.CITUS:
        this.multicareMobileEnabled = true;
        this.showMulticareSection = true;
        break;
      case Products.EFORMS:
        this.multicareEformsEnabled = true;
        this.showMulticareSection = true;
        break;
      case Products.SNF:
        this.showSnfAccess = true;
        break;
      case Products.SL:
        this.enableSLAutoProvisioning = true;
        break;
      case Products.LPC:
        this.showLpcAccess = true;
        break;
      case Products.PP:
        this.showPPAccess = true;
        break;
      case Products.RTO:
        this.showRTOAccess = true;
        break;
      case Products.PD:
        this.showPdOfficeData = true;
        break;
      case Products.TS:
        this.showTrueSenseAccess = true;
        break;
      case Products.SIGMACARE:
        this.showSigmaCareAccess = true;
        break;
      case Products.S4B:
        this.solutionsForBusinessModuleOptions = [];
        this.showSolutionsForBusinessAccess = true;
        break;
      default:
        break;
    }
  }

  public resetAccess() {
    this.showMulticareSection = false;
    this.multicareMobileEnabled = false;
    this.multicareEformsEnabled = false;
    this.showSnfAccess = false;
    this.enableSLAutoProvisioning = false;
    this.showLpcAccess = false;
    this.showPPAccess = false;
    this.showRTOAccess = false;
    this.showPdOfficeData = false;
    this.showTrueSenseAccess = false;
    this.showSigmaCareAccess = false;
    this.showSolutionsForBusinessAccess = false;
    this.createUserForm.controls['mcmdRole'].setErrors(null);
    this.createUserForm.controls['eFormsRole'].setErrors(null);
    this.createUserForm.controls['rtoRole'].setErrors(null);
    this.createUserForm.controls['configId'].setErrors(null);
    this.createUserForm.controls['sigmaCareProvisioned'].setValue(false);
    this.showPhysicianNppaCheckbox = false;
    this.isPhysicianNppaUser = false;
    this.createUserForm.controls['physicianNppaEnabled'].setValue(false);
  }

  public async environmentChanged(option) {
    this.loading = true;
    this.resetAccess();
    this.createUserForm.get("configId").setValue(this.user.configId.trim());
    const snfUserFormValidation = ["userType", "corporationName", "role", "primaryDiscipline"];
    if (this.user.configId) {
      await this.configurationService.getConfigurationFeaturesByConfigId(this.user.configId).subscribe(value => {
        value.productsNeeded.forEach(element => this.checkProductAccess(element['key']));
        value.sharedComponents.forEach(key => this.checkProductAccess(key));

        if (value.ssoIntegrations) {
          value.ssoIntegrations.forEach(key => this.checkProductAccess(key));
        }

        if (value.sharedComponents.includes("bp.idm.auth.physician.enabled")) {
          this.showPhysicianNppaCheckbox = true;
        }else {
          this.showPhysicianNppaCheckbox = false;
        }

        if (value.productsNeeded.some(product => product.key === "sb.module.enabled")) {
          if (value.productsNeeded.some(product => product.key === "sb.module.efa.enabled")) {
            this.solutionsForBusinessModuleOptions.push({ id: 'EntranceFeeAmortization', name: 'Entrance Fee Amortization' });
          }
          if (value.productsNeeded.some(product => product.key === "sb.module.pnsm.enabled")) {
            this.solutionsForBusinessModuleOptions.push({ id: 'ParkingStorageManagement', name: 'Parking & Storage Management' });
          }
        }
        
        if(this.showSnfAccess){
          //validate SNF form if SNF access is displayed
          for (let controlName of snfUserFormValidation) {
            if(controlName === 'primaryDiscipline'){
              this.createUserForm.get(controlName).addValidators(_ => RoleDisciplineValidator.validate(this.createUserForm, this.roles));
            }else if(controlName === 'role'){
              console.log('Adding role validators');
              this.createUserForm.get(controlName).addValidators(_ => RoleDisciplineValidator.validate(this.createUserForm, this.roles));
              this.createUserForm.get(controlName).addValidators(_ => AccessSectionValidator.validate(this.createUserForm));
            }else{
              this.createUserForm.get(controlName).addValidators(_ => AccessSectionValidator.validate(this.createUserForm));
            }
          }
        }else{
          for (let controlName of snfUserFormValidation) {
            this.createUserForm.get(controlName).clearValidators();
          }
        }
        for (let controlName of snfUserFormValidation) {
          this.createUserForm.get(controlName).updateValueAndValidity();
        }
        //exclude LMA from non SNF customers
        if (this.showSnfAccess) {
          this.adminToolRoleData = this.adminToolRoleDefaultData;
        } else {
          this.adminToolRoleData = this.adminToolRoleNonLmaData;
        }
        if(this.showPdOfficeData){
          this.userDetailService.getPdOffices(this.user.configId).subscribe(dl => {
            this.pdOfficeData = dl.map(x => { return { text: x.name, id: x.id.toString() }; });
          }, error => {
            this.messageService.sendError(getAlertMessage(error).message);
          });
        }
        if(this.showLpcAccess){
          this.userDetailService.getLpcRoles(this.user.configId).subscribe(lr=>{
            this.lpcRoleOptions = lr.map<IMultiSelectOption>(x => { return { id: x.roleName, name: x.roleName }; });
          }, error => {
            this.messageService.sendError(getAlertMessage(error).message);
          });
        }
      });
      this.loading = false;
    }

    if (option) {
      this.user.configName = option.text;
    }

    this.user.corporationName = "";
    this.user.careSettingName = "";
    this.user.role = "";
    let isLMAUser = await this.securityService.isUserManagementLocalAdmin().toPromise() || this.user.adminToolRole == "LMA";
    if (isLMAUser) {
      this.user.userType = "Care Setting";
    } else {
      this.user.userType = "";
    }
    this.user.adminToolRole = "";
    this.userTypeChanged(false);
    this.corporationChanged(null);
    this.roleChanged(null);
    this.loading = false;
  }

  public roleChanged(roleName) {
    if(this.treeviewComponent) { this.treeviewComponent.onFilterTextChange(''); }
    this.checkRDLAccess();
    if (!this.user.role || !this.user.role.trim())
      return;
    this.mcmdRoleChanged();
    this.eFormsRoleChanged();
    this.solutionsForBusinessModulesChanged();
    this.paymentPortalRoleChanged();
    this.rtoRoleChanged();
    this.setDiscipline();
    if (!this.isDisciplineRequired) {
      this.user.primaryDiscipline = null;
    }
    setTimeout(() => this.userService.createRDLSearchClearButton(this.element, this.renderer, this.treeviewComponent), 100);
    if(this.createUserForm.get('role').value){
      this.createUserForm.get('role').setErrors(null)
    }
  }

  adminToolRoleDataContains(roleId: string) {
    return this.adminToolRoleDataDictionary.has(roleId) ;
  }

  private checkRDLAccess() {
    this.corporateLimited = false;
    if (this.user.userType == UserTypeNames.Corporate) {
      let role = getRoleFromName(this.roles, this.user.role);
      if (role) {
        this.corporateLimited = role.corporateLimited;
      }
    }
  }

  private setDiscipline() {
    this.isDisciplineRequired = false;
    let role = getRoleFromName(this.roles, this.user.role);

    if (!role) {
      role = this.getCustomData(this.user.role);
    }
    if (role) {
      this.isDisciplineRequired = role.disciplineRequired;
      this.isCustomRole = role.isCustomData;
    }


  }

  public roleSettings = {
    tags: true, placeholder: 'Not Selected', width: '100%',
    createTag: (params) => this.createRoleOption(params)
  };


  public getCustomData(name: string) {
    let data: any = {};
    data.disciplineRequired = true;
    data.isCustomData = true;
    data.name = name;
    return data;
  }

  createRoleOption(params: any) {
    let term = params.term.trim();
    if (!term)
      return;

    return {
      id: term,
      text: term,
      data: this.getCustomData(term)
    }

  }

  isDummyEmail = true;

  public async userAccessTypeChanged() {
    if (this.isPhysicianNppaUser) {
      this.userTypeData = [{ text: 'Corporate', id: 'Corporate' }];
    } else {
      this.userTypeData = await this.userDetailService.getUserTypes();
    }

    if (this.user.adminToolRole == "LMA" || this.user.adminToolRole == "LLA") {
      this.user.userType = "Care Setting";
    }
    else {
      this.user.userType = "";
    }
    this.userTypeChanged(true);

    setTimeout(  () => {
      this.user.role = null;
      this.createUserForm.get("primaryDiscipline").setValue(null);
    });
  }

  private validateProductRoleSelection(controlName: string, value: any): void {
    this.createUserForm.controls[controlName].setErrors(null);

    const hasRole = this.user.role && this.user.role.trim();
    let hasValue = false;

    // Check if the field has a meaningful value
    if (Array.isArray(value)) {
      hasValue = value.length > 0;
    } else {
      hasValue = value && value !== 'Not Selected' && value.trim() !== '';
    }

    if (!hasRole && hasValue) {
      this.createUserForm.controls[controlName].setErrors({ 'invalid': true });
    }
  }

  public mcmdRoleChanged() {
    this.validateProductRoleSelection('mcmdRole', this.user.mcmdRole);
  }

  public eFormsRoleChanged() {
    this.validateProductRoleSelection('eFormsRole', this.user.eFormsRole);
  }

  public solutionsForBusinessModulesChanged() {
    this.validateProductRoleSelection('solutionsForBusinessModules', this.user.solutionsForBusinessModules);
  }

  public paymentPortalRoleChanged() {
    this.validateProductRoleSelection('paymentPortalRole', this.user.paymentPortalRole);
  }

  public rtoRoleChanged() {
    this.validateProductRoleSelection('rtoRole', this.user.rtoRole);
  }

  public userTypeChanged(resetUserInfo = true) {

    this.createUserForm.controls['configId'].setErrors(null);

    if(!this.user.configId) {
      this.createUserForm.controls['configId'].setErrors({ 'invalid': true });
      this.scrollToTop();
      return;
    }

    let roles = [];
    let disciplines = [];
    if(this.treeviewComponent) { this.treeviewComponent.onFilterTextChange(''); }

    if (this.user.userType.trim()) {
      this.corporations = this.userDetailOptions.filter(x => x.configId == this.user.configId).map
        (x => { return { text: x.name, id: x.name }; });
      //had to add if condition on else to not override the dropdown when physician ppa is checked and corps get loaded since
      //there is no usertype for physician nppa users
    } else if (!this.isPhysicianNppaUser) {
      this.corporations = [];
    }
    this.userDetailService.addDefaultOption(this.corporations);

    let currentCorporation = this.getCurrentCorporation();
    if (!currentCorporation)
      return;

    let currentFacility: UserDetailOptionsFacility | any = currentCorporation.facilities.firstOrDefault(x => x.name == this.user.careSettingName, {});

    //Had to add and statement because we are forcing usertype to corporate for physician nppa users
    //but need to load special user templates for the roles array
    if (this.user.userType == UserTypeNames.Corporate && !this.isPhysicianNppaUser) {
      roles = currentCorporation.roles;
    } else if (this.user.userType == UserTypeNames.CareSetting) {
      roles = currentFacility.roles;
    } else if (this.isPhysicianNppaUser) {
      roles = this.physicianNppaTemplates;
    }

    roles = roles || [];

    if (resetUserInfo) {
      this.user.role = null;
      this.user.primaryDiscipline = null;
      this.selectedRegions = null;
      this.user.careSettingName = null;
      this.user.corporationName = null;
      this.corporationChanged("");
      roles = [];
    }

    this.roles = roles.map(x => { return { text: x.name, id: x.name, data: x }; });
    this.userDetailService.addDefaultOption(this.roles);

    this.roleChanged(null);

    if (this.user.userType != this.careSettingName) {
      this.user.careSettingName = null;
      this.user.primaryDiscipline = null;
    }

  }
  public customerFederationEnabled = false;
  public scimEnabled = false;
  public federationLoginIdEnabled = false;
  public mfaEnabled = false;

  private async loadOptions() {
    if (this.isPhysicianNppaUser) {
      this.userTypeData = [{ text: 'Corporate', id: 'Corporate' }];
    } else {
      this.userTypeData = await this.userDetailService.getUserTypes();
    }

    try {
      this.alert = null;
      this.accessDisabled = false;

      const toggles = await this.toggleService.get().toPromise();
      this.customerFederationEnabled = toggles.azureADEnabled;
      this.federationLoginIdEnabled = toggles.federatedLoginIdEnabled;
      this.scimEnabled = toggles.scimEnabled;
      const mfaCustomerData = await this.userCustomerService.getSettings().toPromise();
      this.mfaEnabled = mfaCustomerData.mfaEnabled && mfaCustomerData.customerEnabledMFA;
      this.adminToolRoleDefaultData = await this.userService.getUserAccessTypesOptions(true);
      this.adminToolRoleData = this.adminToolRoleDefaultData;
      this.adminToolRoleNonLmaData = this.userService.getNonLmaUserAccessTypes();

      this.environmentLoading = true;

      if (this.mfaEnabled) {
        const isCustomerCitusEnabled = await firstValueFrom(this.securityService.isCustomerCitusEnabled());

        this.userService.getSignonPolicies().subscribe((values) => {
          const visiblePolicies = values.filter(policy =>
            policy && policy.name && !shouldHidePolicy(policy.name, isCustomerCitusEnabled)
          );

          this.allPolicies = visiblePolicies;
          this.signOnOptions = this.allPolicies.map<IMultiSelectOption>(x => { return { id: x.id, name: x.name, classes: (x.status !== 'Active') ? 'disableItem' : '' }; });
          this.user.factor = {
            signOnPolicyList: []
          };
        });
      }


      await this.userDetailService.getOptions().pipe(map(x => {
        this.userDetailOptions = x;
        this.environments = this.userDetailOptions.map
          (x => { return { text: x.configName, id: x.configId.toString() } });

        if (this.environments.length == 1) {
          this.user.configId = this.environments[ 0 ].id;
          this.environmentChanged(this.environments[ 0 ]);
        }

        this.userDetailService.addDefaultOption(this.environments);
        this.environmentLoading = false;
      })).toPromise();


    } catch (e) {
      this.accessDisabled = true;
      this.environmentLoading = false;
      this.alert = new Alert(AlertType.WARNING, "The Access section on this page is temporarily not available.");
      console.error(e);

    }

  }

  ngOnDestroy(): void {
    this._success.unsubscribe();
  }


  save() {
    this.messageService.send(MessageType.ProcessingOn);
    this.waiting = true;
    this.alert = null;

    let modalRef: NgbModalRef;
    const options: NgbModalOptions = {
      backdrop: 'static',
      centered: true
    };

    // Display creating user modal after 5 seconds if the user hasn't been created.
    //setTimeout(() => {
    //  if (this.waiting) {
    //    modalRef = this.modalService.open(CreateUserMessageComponent, options);

    // Close the modal if it is still being displayed after a total of 60 seconds.
    setTimeout(() => {
      if (this.waiting) {
        //this.checkModal(modalRef);
        this.messageService.send(MessageType.ProcessingOff);
        this.showMessage("No confirmation of user creation after 60 seconds.");
      }
    },
      55000);
    //}
    //},
    //  5000);

    if (!this.isDisciplineRequired) {
      this.user.primaryDiscipline = null;
      this.createUserForm.get('primaryDiscipline').setValue(null);
    }

    const user: User = Object.assign({}, this.user, this.createUserForm.value);
    if (user.password == null)
      delete user.password;

    if(!this.isCustomerAdmin && !this.isUserLocationLimitedAdmin && !this.isLocationAdmin) {
      delete user.deactivationDate;
    }

    user.userName = `${user.userName.trim()}@${this.selectedDomain}`;
    if (this.customerFederationEnabled && user.federatedIdentity && this.federationLoginIdEnabled) {
      user.federatedLoginID = `${user.federatedLoginID.trim()}@${this.selectedFederatedLoginIdDomain}`
    } else {
      delete user.federatedLoginID;
    }
    if (!this.customerFederationEnabled) {
      delete user.federatedIdentity;
    }

    if(this.mfaEnabled && !this.user.federatedIdentity && this.user.factor)
      this.user.factor.signOnPolicyList = this.allPolicies.filter(o1 => this.signOnPolicies.some(o2 => o1.id === o2));

    if(this.customerFederationEnabled && user.federatedIdentity && this.mfaEnabled && user.factor != null){
      delete user.factor;
    }

    if (user.userType)
      user.userType = user.userType.trim();

    if (user.role)
      user.role = user.role.trim();

    if (user.corporationName)
      user.corporationName = user.corporationName.trim();


    if (user.primaryDiscipline)
      user.primaryDiscipline = user.primaryDiscipline.trim();

    if (!user.email.trim()) {
      user.email = this.userService.getDummyEmail();
    }

    if (user.lpcRoles)
      user.lpcRoles = user.lpcRoles;


    if(!user.mcmdRole || user.mcmdRole === 'Not Selected')
      user.mcmdRole = '';
    if(!user.paymentPortalRole || user.paymentPortalRole === 'Not Selected')
      user.paymentPortalRole = '';
    if(!user.rtoRole || user.rtoRole === 'Not Selected')
      user.rtoRole = '';

    if(user.deactivationDate)
      user.deactivationDate = user.deactivationDate.toISOString().split('T')[0];

    user.userRegions = this.selectedRegions;

    const stateDeaNumbersArray = this.createUserForm.get('stateDeaNumbers')?.value;
    if (stateDeaNumbersArray) {
      const validEntries = stateDeaNumbersArray.filter((entry: any) => {
        return entry.stateForDeaNumber?.trim() || entry.deaNumber?.trim();
      });
      user.stateDeaNumbers = validEntries;
    }

    if(this.newFacilityRoleAssignments && this.newFacilityRoleAssignments.length > 0) {
      user.facilityRoleAssignments = this.newFacilityRoleAssignments;
    }

    this.userService
      .create(user, environment.enableSLAutoProvisioning.toLowerCase() === "true")
      .subscribe(
        res => {
          // If user was created successfully, ssoid must have some value.
          if (res.ssoid != null && res.ssoid.length > 0) {
            this.router
              .navigate([ '/user', res.ssoid ], { queryParams: { 'createSlProvisioned': user.slProvisioned } })
              .then(status => {
                if (status) {
                  this.checkModal(modalRef);
                  this.waiting = false;
                  this.messageService.send(MessageType.UserCreated);
                }
              });
          } else {
            this.checkModal(modalRef);
            this.showMessage("No SSOID created for the user.");
            this.waiting = false;
          }
          if(this.treeviewComponent) { this.treeviewComponent.onFilterTextChange(''); }
          this.messageService.send(MessageType.ProcessingOff);
        },
        err => {
          if(this.treeviewComponent) { this.treeviewComponent.onFilterTextChange(''); }
          this.messageService.send(MessageType.ProcessingOff);
          /* if (err.status === 409) {
            this.alert = new Alert(AlertType.DANGER, 'Username or email already exists.');
          } else if (err.status === 400) {
            this.alert = new Alert(AlertType.DANGER, err.message);
          } else {
            this.alert = getAlertMessage(err);
          } */
          this.checkModal(modalRef);
          this.alert = getAlertMessage(err);
          window.scroll(0, 0);
          this.waiting = false;
        }
      );
  }

  checkModal(modalRef: NgbModalRef) {
    if (modalRef) {
      const c = <CreateUserMessageComponent>modalRef.componentInstance;
      c.close();
    }
  }

  showMessage(message: string) {
    this.alert = new Alert(AlertType.DANGER, message);
    window.scroll(0, 0);
  }

  valueChange() {

  }

  validatePassword() {
    if (this.customerFederationEnabled && this.user.federatedIdentity)
      return true;

    if (this.passwordSetBy === 'Admin') {
      return this.passowrdValidationSvc.validatePassword(this.createUserForm.value.password, this.createUserForm.value.userName, this.selectedDomain, this.createUserForm.value.firstName, this.createUserForm.value.lastName, true, true, true).isValid();
    } else {
      return true;
    }
  }
  validPassword: boolean;
  accessSelectionsRequired(): boolean {
    // Get control references
    const userTypeCtrl = this.createUserForm.get('userType');
    const corporationNameCtrl = this.createUserForm.get('corporationName');
    //const careSettingNameCtrl = this.createUserForm.get('careSettingName');
    const roleCtrl = this.createUserForm.get('role');

    //const lpcRoleCtrl = this.createUserForm.get('lpcRole');
    const isRequired = (((userTypeCtrl.value === undefined) ||
        (userTypeCtrl.value === null) ||
        (userTypeCtrl.value.trim() === '')) &&
      ((corporationNameCtrl.value === undefined) ||
        (corporationNameCtrl.value === null) ||
        (corporationNameCtrl.value.trim() === '')) &&
      ((roleCtrl.value === undefined) || (roleCtrl.value === null) || (roleCtrl.value.trim() === '')));

    return !isRequired;
  }



  onChangeItem(item: TreeviewItem) {
    if (!_.isNil(item.children)) {
      item.children.forEach(child => {
        if (item.checked) {
          child.setCheckedRecursive(item.checked);
          child.disabled = item.checked;
        } else {
          child.disabled = item.checked;
          child.setCheckedRecursive(item.checked);
        }
      });
    }
    this.treeviewComponent.raiseSelectedChange();
  }

  onSelectedChange(downlineItems: DownlineTreeviewItem[]) {
    this.selectedRegions = [];
    downlineItems.forEach(downlineItem => {
      const item = downlineItem.item;
      const value = item.value;
      let parent = downlineItem.parent;

      if (item.disabled) {
        // This will be the root of the checked items which is not disabled. This is to reflect the functionality we have in SNF.
        while (!_.isNil(parent) && parent.item.checked) {
          if (!parent.item.disabled) {
            let obj = {
              id: parent.item.value.id,
              name: parent.item.value.name,
              type: parent.item.value.type
            }
            const index = this.selectedRegions.findIndex(item => item.id === obj.id && item.type === obj.type);
            if (index === -1) {
              this.selectedRegions.push(obj);
            }
          }
          parent = parent.parent;
        }
      } else {
        let obj = {
          id: value.id,
          name: value.name,
          type: value.type
        }
        this.selectedRegions.push(obj)
      }
    });
  }

  getFormValidationErrors() {

    Object.keys(this.createUserForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.createUserForm.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[ keyError ]);
        });
      }
    });

    console.log("raw", this.createUserForm.getRawValue());
    console.log("user", this.user);
  }

  showHidePassword() {
    this.showPassword = !this.showPassword;
  }

  copyText() {
    copyToClipboard(this.createUserForm.value.password);
  }

  public disciplineSettings = {
    tags: false, placeholder: 'Not Selected', width: '100%'
  };

  scrollToTop() {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }


  async onPhysicianNppaChange(isChecked: boolean): Promise<void> {
    const emailControl = this.createUserForm.get('email');
    const primaryPhoneControl = this.createUserForm.get('primaryPhone');
    const titleControl = this.createUserForm.get('title');
    if (isChecked) {
      emailControl?.addValidators(Validators.required); // Add required validator
      primaryPhoneControl?.addValidators(Validators.required);
      titleControl?.addValidators(Validators.required);
      this.createUserForm.patchValue({ usesMatrixcare: true });

      this.isPhysicianNppaUser = true;
      this.user.deactivationDate = "";
      this.createUserForm.patchValue({ usesMatrixcare: true, adminToolRole: 'RU', deactivationDate: "" });
      this.user.usesMatrixcare=true;
      // Set userType no admin rights if physician user
      this.user.adminToolRole = 'RU';
      this.userTypeData = [{ text: 'Corporate', id: 'Corporate' }];
      //reset the value to prevent it from selecting top option
      this.user.userType = null;
      emailControl?.addValidators(Validators.required); // Add required validator
      primaryPhoneControl?.addValidators(Validators.required);
      titleControl?.addValidators(Validators.required);
      //load the corporations
      this.corporations = this.userDetailOptions.filter(x => x.configId == this.user.configId).map
      (x => { return { text: x.name, id: x.name }; });
      const configId = this.user.configId; // Example: Get configId from route params
      this.isDisciplineRequired=false;
      // Build a Set of facility IDs the current user can access (from referenceData, already LMA-filtered)
      const accessibleFacilityIds = new Set<number>();
      if (configId) {
        await this.fetchAndProcessCorporateStructure(configId);
        for (const option of this.userDetailOptions) {
          if (String(option.configId) === String(this.user.configId)) {
            option.facilities.forEach(f => accessibleFacilityIds.add(f.id));
            break;
          }
        }
      }

      // Use the full facility list from corporateStructureObject (already fetched, not LMA-filtered)
      const allFacilities: { id: number; name: string }[] =
        (this.corporateStructureObject?.facilities || []).map((f: any) => ({ id: f.id, name: f.name }));
      this.facilitiesForRoleAssignment = allFacilities;

      this.facilityRoleAssignmentForm = this.fb.group({
        facilities: this.fb.array(allFacilities.map(facility =>
          this.fb.group({
            checked: false,
            id: [facility.id, Validators.required],
            name: [facility.name, Validators.required],
            role: [''], // Default to an empty if roles are undefined
            accessible: [!this.isLocationAdmin || accessibleFacilityIds.has(facility.id)]
          })
        ))
      });
      this.selectAllChecked = false;
      this.defaultRole = '';
      this.showSelectAll = this.isCustomerAdmin ||
        (this.isLocationAdmin && !this.isUserLocationLimitedAdmin && accessibleFacilityIds.size === allFacilities.length);
      // Initialize the `visible` property for each facility
      this.facilities.controls.forEach((control) => {
        if (!control.get('visible')) {
          (control as FormGroup).addControl('visible', new FormControl(true));
        }
      });
// Set the flag to true after the form is initialized
      this.isFacilityRoleAssignmentFormLoaded = true;
    } else{
      this.isPhysicianNppaUser=false;
      this.selectAllChecked = false;
      this.defaultRole = '';
      this.showSelectAll = false;
      this.corporations = [];
      this.roles = [];
      this.careSettings = [];
      this.disciplines = [];
      this.selectedRegions = [];
      this.user.role = "";
      this.user.careSettingName = "";
      this.user.primaryDiscipline = "";
      this.user.userType = "";
      this.userTypeData = await this.userDetailService.getUserTypes();
      this.isDisciplineRequired = false;
      this.isFacilityRoleAssignmentFormLoaded = false;
      this.roleChanged(null);
      const snfUserFormValidation = ["userType", "corporationName", "role", "primaryDiscipline"];
      for (let controlName of snfUserFormValidation) {
        this.createUserForm.get(controlName).clearValidators();
      }

      // Clear validators for email, primaryPhone, title when unchecking Physician NP/PA
      emailControl?.removeValidators(Validators.required);
      emailControl?.updateValueAndValidity();
      primaryPhoneControl?.removeValidators(Validators.required);
      primaryPhoneControl?.updateValueAndValidity();
      titleControl?.removeValidators(Validators.required);
      titleControl?.updateValueAndValidity();

      // Remove controls added by physician-nppa-user-child component
      const physicianControls = [
        'clinicMedCenter', 'fax', 'addressLine1', 'pager', 'addressLine2',
        'directEmail', 'city', 'state', 'zip', 'upin', 'taxonomyCode',
        'licenseNumber', 'npi', 'taxIdNumber', 'medicaidNumber',
        'stateDeaNumbers', 'medicareNumber', 'nadeanNumber'
      ];
      for (const controlName of physicianControls) {
        if (this.createUserForm.contains(controlName)) {
          this.createUserForm.removeControl(controlName);
        }
        // Clear the value from user model as well
        this.user[controlName] = null;
      }
    }
    emailControl?.updateValueAndValidity(); // Update the control's validation status
    primaryPhoneControl?.updateValueAndValidity();
    titleControl?.updateValueAndValidity();
    // Optionally, update the form's validity
    this.createUserForm.updateValueAndValidity();
  }

  // reset multicare section
  public resetMultiCareSection() {
    this.user.userType = null;
    this.user.role = null;
    this.user.primaryDiscipline = null;
    this.selectedRegions = null;
    this.user.careSettingName = null;
    this.user.corporationName = null;
    this.corporationChanged("");
    this.user.mcmdRole = '';
    this.user.eFormsRole = '';
    this.user.solutionsForBusinessModules = [];
    this.user.paymentPortalRole = '';
    this.user.rtoRole = '';

    const snfUserFormValidation = ["userType", "corporationName", "role", "primaryDiscipline"];
    for (let controlName of snfUserFormValidation) {
      const control = this.createUserForm.get(controlName);
      control.clearValidators();
      control.setValue('');
      control.markAsUntouched();
      control.markAsPristine();
      control.updateValueAndValidity();
    }

    // Re-add validators if SNF access is shown
    if(this.showSnfAccess) {
      for (let controlName of snfUserFormValidation) {
        if(controlName === 'primaryDiscipline'){
          this.createUserForm.get(controlName).addValidators(_ => RoleDisciplineValidator.validate(this.createUserForm, this.roles));
        } else if(controlName === 'role'){
          this.createUserForm.get(controlName).addValidators(_ => RoleDisciplineValidator.validate(this.createUserForm, this.roles));
          this.createUserForm.get(controlName).addValidators(_ => AccessSectionValidator.validate(this.createUserForm));
        } else {
          this.createUserForm.get(controlName).addValidators(_ => AccessSectionValidator.validate(this.createUserForm));
        }
        this.createUserForm.get(controlName).updateValueAndValidity();
      }
    }

    // Force form validation update
    this.createUserForm.updateValueAndValidity();
  }

  protected logFormErrors(): void {
    this.createUserForm.get('corporationName').updateValueAndValidity();
    this.createUserForm.get('role').updateValueAndValidity();
    if (!this.createUserForm) {
      console.log('Form is not initialized.');
      return;
    }

    Object.keys(this.createUserForm.controls).forEach(controlName => {
      const control = this.createUserForm.get(controlName);
      if (control && control.invalid) {
        if (control.value) {
          control.setErrors(null);
        }
        console.log(`Control: ${controlName}, Value: ${control.value}, Errors:`, control.errors);
      }
    });
  }

  onFacilityRoleCheckedChange(index: number): void {
    const facilitiesArray = this.facilityRoleAssignmentForm.get('facilities') as FormArray;
    const facilityGroup = facilitiesArray.at(index);
    const roleControl = facilityGroup.get('role');

    if (facilityGroup.get('checked')?.value) {
      // Add required validator to the role field
      roleControl?.addValidators(Validators.required);
      roleControl?.updateValueAndValidity();
      // Update the parent form's validity
      this.facilityRoleAssignmentForm.updateValueAndValidity();
    } else {
      this.selectAllChecked = false;

      // Clear the value and reset the control state
      roleControl?.setValue(null, { emitEvent: false });
      roleControl?.reset(); // Resets the control to its initial state
      roleControl?.clearValidators();
      roleControl?.updateValueAndValidity();

      // Trigger Angular's change detection explicitly
      this.cdr.detectChanges();

      // Update the parent form's validity
      this.facilityRoleAssignmentForm.updateValueAndValidity();

      // Remove the facility from the newFacilityRoleAssignments array if unchecked
      const facilityId = facilityGroup.get('id')?.value;
      this.newFacilityRoleAssignments = this.newFacilityRoleAssignments.filter(
        assignment => assignment.id !== facilityId
      );
    }
  }

  onFacilityRoleAssignmentChange(index: number): void {
    const facilitiesArray = this.facilityRoleAssignmentForm.get('facilities') as FormArray;
    const facilityGroup = facilitiesArray.at(index);
    const facilityId = facilityGroup.get('id')?.value;
    const newRole = facilityGroup.get('role')?.value;

    if (facilityId && newRole) {
      // Check if the facility ID already exists in the array
      const existingAssignment = this.newFacilityRoleAssignments.find(assignment => assignment.id === facilityId);

      if (existingAssignment) {
        // Update the role if it is different
        if (existingAssignment.role !== newRole) {
          existingAssignment.role = newRole;
        }
      } else {
        // Add a new assignment if it doesn't exist
        this.newFacilityRoleAssignments.push({
          id: facilityId, // Assuming `id` exists in the form group
          role: newRole
        });
      }
    }
  }

  onFacilityListScroll(event: Event): void {
    this.facilityListScrolled = (event.target as HTMLElement).scrollTop > 0;
  }

  onSelectAllChange(checked: boolean): void {
    this.selectAllChecked = checked;
    const facilitiesArray = this.facilityRoleAssignmentForm.get('facilities') as FormArray;

    if (checked) {
      facilitiesArray.controls.forEach((control: AbstractControl) => {
        if (!control.get('accessible')?.value) return;
        control.get('checked')?.setValue(true, { emitEvent: false });
        if (this.defaultRole) {
          control.get('role')?.setValue(this.defaultRole, { emitEvent: false });
          const facilityId = control.get('id')?.value;
          const existing = this.newFacilityRoleAssignments.find(a => a.id === facilityId);
          if (existing) {
            existing.role = this.defaultRole;
          } else {
            this.newFacilityRoleAssignments.push({ id: facilityId, role: this.defaultRole });
          }
        }
      });
    } else {
      facilitiesArray.controls.forEach((control: AbstractControl) => {
        control.get('checked')?.setValue(false, { emitEvent: false });
        control.get('role')?.setValue('', { emitEvent: false });
      });
      this.newFacilityRoleAssignments = [];
      this.defaultRole = '';
    }
    this.cdr.detectChanges();
    // Force select2 components to re-render their displayed value
    setTimeout(() => {
      facilitiesArray.controls.forEach((control: AbstractControl) => {
        const roleControl = control.get('role');
        roleControl?.setValue(roleControl.value);
      });
    }, 0);
  }

  onDefaultRoleChange(role: string): void {
    this.defaultRole = role;
    if (!this.selectAllChecked) return;
    const facilitiesArray = this.facilityRoleAssignmentForm.get('facilities') as FormArray;
    facilitiesArray.controls.forEach((control: AbstractControl) => {
      if (!control.get('accessible')?.value) return;
      if (!control.get('checked')?.value) return;
      control.get('role')?.setValue(role, { emitEvent: false });
      const facilityId = control.get('id')?.value;
      const existing = this.newFacilityRoleAssignments.find(a => a.id === facilityId);
      if (existing) {
        existing.role = role;
      } else {
        this.newFacilityRoleAssignments.push({ id: facilityId, role });
      }
    });
    this.cdr.detectChanges();
    // Force select2 components to re-render their displayed value
    setTimeout(() => {
      facilitiesArray.controls.forEach((control: AbstractControl) => {
        const roleControl = control.get('role');
        if (roleControl?.value) roleControl.setValue(roleControl.value);
      });
    }, 0);
  }

  getCheckedCount(): number {
    const facilitiesArray = this.facilityRoleAssignmentForm.get('facilities') as FormArray;
    return facilitiesArray.controls.filter(facility => facility.get('checked')?.value).length;
  }

}
